import React, { useContext, useState, useEffect, useMemo, useCallback } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MoreIcon from "@mui/icons-material/MoreVert";
import { AuthContext } from "auth/Auth";
import { useHookstate } from "@hookstate/core";
import { Modal, Typography } from "@mui/material";
import CloseIcon from "../../assets/svgIcons/CloseIcon";
import Select from "@mui/material/Select";
import LanguageMenuIcon from "assets/svgIcons/LanguageMenuIcon";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LogoutIcon from "assets/svgIcons/LogOutIcon";
import UnLockIcon from "assets/svgIcons/UnlockMenuIcon";
import LockIcon from "assets/svgIcons/LockIcon";
import { Loader } from "commonComponents/Loader/Loader";
import {
  FaSortNumericDownAlt,
  FaSortNumericUp,
  FaSortAlphaDown,
  FaSortAlphaDownAlt
} from "react-icons/fa";
import { FaClockRotateLeft } from "react-icons/fa6";

import {
  SIDENAV_GLOBAL_STATE,
  FLEET_GLOBAL_STATES,
  MAP_GLOBAL_STATES,
  SITELOCATION_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
  CHECKBOX_LOADER,
  GlobalCourseIdState,
  GLOBAL_SITE_SEARCH,
  APP_CONSTANTS_STATE,
  COMMON_COMPONENTS_STATES,
  LANGUAGE_GLOBAL_STATE,
  ADS_GLOBAL_STATE,
  MAX_HOLES_GLOBAL_STATE,
} from "../../globalStore/globalStore";
import Logo from "assets/images/club-car-connect-logo.png";
import {
  Container,
  HelpContainer,
  SiteBoxContainer,
  SearchWrapper,
  SearchSection,
  ResentSite,
  AllSite,
  AllSiteBtn,
  ChangePasswordPopup,
} from "commonComponents/Navbar/NavbarStyled";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import HelpIcon from "assets/svgIcons/HelpIcon";
import GlobeIcon from "assets/svgIcons/GlobeIcon";
import SelectArrow from "assets/svgIcons/SelectArrowIcon";
import { useNavigate } from "react-router-dom";
import {
  setSiteIdData,
  setViewDistanceYardsAction,
  setAppDataReduxStateAction,
} from "redux/reduxToolkitServices/_commonReducers/persistedLocalStorageReducer";
import { SiteBoxInput } from "./SiteBoxInput";
import moment from "moment";
import { PopUpContainer } from "assets/css/globle";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import _ from "lodash";
import { useSnackbar } from "notistack";

export const Navbar = () => {
  const { closeSnackbar } = useSnackbar();

  const { siteSearchValue, isFirstUpdate } = useHookstate(GLOBAL_SITE_SEARCH);
  const { localSiteTimeState } = useHookstate(COMMON_COMPONENTS_STATES);
  const { selectedLang } = useHookstate(LANGUAGE_GLOBAL_STATE);
  const { detectChangeMaxHolesAllowed } = useHookstate(MAX_HOLES_GLOBAL_STATE);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { globalCourseId, resetGlobalCourseId } = useHookstate(GlobalCourseIdState);

  const { redirectState, alertMsg, nextStageName } = useHookstate(ADS_GLOBAL_STATE);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [siteSelectionHistory, setSiteSelectionHistory] = React.useState(true);
  const [siteList] = React.useState([]);
  const { handleLogout } = useContext(AuthContext);
  const { sideDrawerState, sideDrawerActiveTabState, subNavDataState } = useHookstate(SIDENAV_GLOBAL_STATE);

  const {
    siteLocationGlobalData,
    singleSiteLocationData,
    dropDownEvent,
    recentSiteState,
  } = useHookstate(SITELOCATION_GLOBAL_STATE);

  const { getCarsCounter } = useHookstate(APP_CONSTANTS_STATE);
  const { siteId, selectSite, hideSubNav, hasSiteChangedAds } = useHookstate(SITEID_GLOBAL_STATE);

  const { weatherAlertGlobalState, weatherAlertPopUpDisplayer } = useHookstate(FLEET_GLOBAL_STATES);

  const {
    addActionZonePolygon,
    openActionZoneWindow,
    getSelectedCarsState,
    callSiteSelection,
    siteListPopupOpen,
    openAZdiscardPopup,
    callAllSiteFunction,
    showTaggedCarArrayClickToDriveInputValueSetter,
    showTaggedCarArrayClickToDrive,
    mapSideNavTabState,
  } = useHookstate(MAP_GLOBAL_STATES);

  const { LoadingState } = useHookstate(CHECKBOX_LOADER);

  const [recentThreeSiteState, setRecentThreeSiteState] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const {
    siteLocationsData,
    siteSettingsData,
    getChangePasswordState,
    getUserRole,
  } = useSelector((state) => state.commonReducers) || [];

  const { siteIdData, appDataReduxState: { distanceunits } = {} } = useSelector((state) => state.firstReducer) || [];

  const [open, setOpen] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showConfirmChangePasswordModal, setshowConfirmChangePasswordModal] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [siteSelectionEvent, setSiteSelectionEvent] = useState(null);

  const handleClose2 = () => {
    setOpen(false);
  };
  const [startDateData] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [endDateData] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [time, setTime] = useState(null);
  const [sortedSites, setSortedSites] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    field: "Name",
    isAscending: true,
  });
  const [nameSortActive, setNameSortActive] = useState(true);
  const [idSortActive, setIdSortActive] = useState(false);
  const [showInternal, setShowInternal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedSite, setSelectedSite] = useState("Choose Site..");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "calc(100% - 40px)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };

  const handleLanguage = () => {
    setAnchorEl(null);
    setOpen(true);
  }

  useEffect(() => {
    const timerID = setInterval(tick, 1000);

    return () => clearInterval(timerID);
  }, [siteSettingsData]);

  const tick = useCallback(() => {
    let formattedTime = new Date().toLocaleTimeString();

    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0 && !_.isNull(siteSettingsData?.TimeZoneOffset)) {
      formattedTime = moment()
        .utcOffset(-siteSettingsData.TimeZoneOffset)
        .format('HH:mm');

      localSiteTimeState.set(formattedTime);
    }

    setTime(formattedTime);
  }, [siteSettingsData, localSiteTimeState, setTime]);

  useEffect(() => {
    weatherAlertGlobalState.set(siteSettingsData?.WeatherAlert);
  }, []);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getAllSiteLocationsServices());
  }, []);

  useEffect(() => {
    if (siteId.get() !== null) {
      siteListPopupOpen.set(false);
      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
      dispatch(COMMON_SERVICES.getFeatureSetServices(siteId.get()));
      dispatch(setSiteIdData(siteId.get()));
      
      // Update dropdown display when siteId changes
      if (siteLocationsData && siteLocationsData.length > 0) {
        const selectedSiteName = siteLocationsData.find(item => item.Id === siteId.get())?.Name;
        if (selectedSiteName) {
          setSelectedSite(selectedSiteName);
        }
      }
    }
  }, [siteId.get()]);

  useEffect(() => {
    if (getChangePasswordState && getChangePasswordState?.success) {
      setShowChangePasswordModal(false);
      setshowConfirmChangePasswordModal(true);
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
    }
  }, [getChangePasswordState]);

  useEffect(() => {
    if (siteLocationsData && Object.keys(siteLocationsData).length > 0) {
      if (siteLocationsData?.length == 1) {
        siteId.set(siteLocationsData[0]?.Id);
        siteLocationGlobalData.set(false);

        localStorage.setItem("recentSite", JSON.stringify(siteLocationsData[0]?.Id));
        localStorage.setItem("RecentThreeSites", JSON.stringify([siteLocationsData[0]?.Id]));
      } else if (siteLocationsData?.length > 1) {
        const filter = siteLocationsData?.filter((item) => {
          return item.Id.toString() === localStorage.getItem("recentSite");
        });
        if (filter.length <= 0) {
          siteId.set(null);
          siteLocationGlobalData.set(true);
          localStorage.removeItem("recentSite");
        }
      }

      if (siteId.get() !== null && !selectSite.get()) {
        setSelectedSite(siteLocationsData?.filter((item) => item.Id == localStorage.getItem("recentSite"))?.map((data) => data.Name));
      }
    }
  }, [siteLocationsData]);

  const filteredData = useMemo(() => {
    let finalData = siteLocationsData?.filter((item) => {
      return (
        item.Id.toString().toUpperCase().includes(searchText) ||
        item.Name.toString().toUpperCase().includes(searchText)
      );
    });
    return finalData;
  }, [siteLocationsData, searchText]);

  useEffect(() => {
    if (filteredData?.length > 0) {
      if (sortConfig.field === "Id") {
        setSortedSites(
          [...filteredData].sort((a, b) => {
            return sortConfig.isAscending ? a.Id - b.Id : b.Id - a.Id;
          })
        );
      } else if (sortConfig.field === "Name") {
        setSortedSites(
          [...filteredData].sort((a, b) => {
            return sortConfig.isAscending
              ? a.Name.localeCompare(b.Name)
              : b.Name.localeCompare(a.Name);
          })
        );
      }
    }
  }, [filteredData, sortConfig]);

  // TODO -- This logic is done for getting site setup data starts here
  useEffect(() => {
    if (siteIdData) {
      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
    }
    let getThreeSite = JSON.parse(localStorage.getItem("RecentThreeSites"));

    if (getThreeSite !== null) {
      siteList.push(...getThreeSite.flat(1));
    }
  }, []);

  useEffect(() => {
    if (siteId.get() !== null) {
      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
    }
  }, [siteIdData]);

  useEffect(() => {
    dispatch(setViewDistanceYardsAction(distanceunits));
  }, [siteIdData]);

  useEffect(() => {
    selectedLang.set(i18next.language);
  }, [i18next.language]);

  useEffect(() => {
    if (callSiteSelection.get()) {
      callSiteSelection.set(false);
      siteLocation(siteSelectionEvent);
    }
  }, [callSiteSelection.get()]);

  useEffect(() => {
    extractRecentData();
  }, [siteListPopupOpen.get()]);

  function siteLocation(event) {
    showTaggedCarArrayClickToDriveInputValueSetter.set([]);
    showTaggedCarArrayClickToDrive.set([]);

    localStorage.removeItem("TaggedCarsData");
    event.preventDefault();
    setSiteSelectionEvent(event);

    if (redirectState.get()) {
      alertMsg.set(true);
      nextStageName.set("siteSelection");
    } else {
      let selectedSiteId = parseInt(event.target.id);
      setSelectedSite(siteLocationsData?.filter((item) => item.Id == selectedSiteId)?.map((data) => data.Name));

      localStorage.setItem("dashCourseId", resetGlobalCourseId.get());
      globalCourseId.set(resetGlobalCourseId.get());
      getCarsCounter.set(0);
      localStorage.setItem("allSite", false);
      subNavDataState.set(localStorage.getItem("subNavDataState"));
      siteLocationGlobalData.set(false);
      recentSiteState.set(false);

      if (siteId.get() === null) {
        selectSite.set(false);

        siteId.set(selectedSiteId);
        singleSiteLocationData.set(true);
        dropDownEvent.set(true);
        localStorage.setItem("recentSite", event.target.id);
        // TODO -- Here we are setting siteId in localstorage using Redux also calling "/GetSiteSettings" api
        dispatch(setAppDataReduxStateAction({ parameterDetector: "sitenumber", value: event.target.id }));

        dispatch(setSiteIdData(event.target.id));
        dispatch(COMMON_SERVICES.getSiteSettingsServices(event.target.id));
        dispatch(COMMON_SERVICES.getCampaignsServices(event.target.id));
        dispatch(COMMON_SERVICES?.getScoreCardServices(event.target.id, startDateData, endDateData));
        dispatch(COMMON_SERVICES.getImageGalleryServices(event.target.id));

        let recentSitesData = JSON.parse(localStorage.getItem("RecentThreeSites"));
        recentSitesData = _.without(recentSitesData, selectedSiteId); // remove it if already in the list (so it moves to top)
        recentSitesData.unshift(selectedSiteId);
        while (recentSitesData.length > 3) recentSitesData.pop(); // limit to 3 most recent sites

        localStorage.setItem("RecentThreeSites", JSON.stringify(recentSitesData));

        if (siteListPopupOpen.get()) siteListPopupOpen.set(false);
        else siteListPopupOpen.set(true);

        siteSearchValue.set("");
        window.location.reload();
      } else {
        selectSite.set(false);
        siteId.set(selectedSiteId);
        siteLocationGlobalData.set(false);
        singleSiteLocationData.set(true);
        dropDownEvent.set(true);
        localStorage.setItem("recentSite", event.target.id);
        // TODO -- Here we are setting siteId in localstorage using Redux also calling "/GetSiteSettings" api
        dispatch(
          setAppDataReduxStateAction({
            parameterDetector: "sitenumber",
            value: event.target.id,
          })
        );
        dispatch(setSiteIdData(event.target.id));
        dispatch(COMMON_SERVICES.getSiteSettingsServices(event.target.id));
        dispatch(COMMON_SERVICES.getCampaignsServices(event.target.id));
        dispatch(COMMON_SERVICES.getScoreCardServices(event.target.id, startDateData, endDateData));
        dispatch(COMMON_SERVICES.getImageGalleryServices(event.target.id));
        dispatch(COMMON_SERVICES.getCarServices(true, siteId.get()))?.then(() => isFirstUpdate.set(true));

        let recentSitesData = JSON.parse(localStorage.getItem("RecentThreeSites"));
        recentSitesData = _.without(recentSitesData, selectedSiteId); // remove it if already in the list (so it moves to top)
        recentSitesData.unshift(selectedSiteId);
        while (recentSitesData.length > 3) recentSitesData.pop(); // limit to 3 most recent sites

        localStorage.setItem("RecentThreeSites", JSON.stringify(recentSitesData));

        if (siteListPopupOpen.get()) siteListPopupOpen.set(false);
        else siteListPopupOpen.set(true);

        siteSearchValue.set("");
        getSelectedCarsState.set([]);
        detectChangeMaxHolesAllowed.set(false);
      }
      openActionZoneWindow.set(false);
      hasSiteChangedAds.set(mapSideNavTabState.get() == "editCampaign");
    }
  }

  const extractRecentData = () => {
    let getStorageData = JSON.parse(localStorage.getItem("RecentThreeSites"));
    let loopData =
      getStorageData &&
      getStorageData?.map((item) => {
        let filterValue = siteLocationsData?.filter(
          (childItem) => childItem.Id == item
        );
        return filterValue;
      });
    setRecentThreeSiteState(loopData?.flat(1));
    return loopData;
  };

  const handleClick = () => {
    if (siteListPopupOpen.get()) siteListPopupOpen.set(false);
    else siteListPopupOpen.set(true);
  };

  const handleClose = () => siteListPopupOpen.set(false);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const OpenUrl = () => {
    const url = "https://help.visage.golf/visage-2/";
    window.open(url, "_blank");
  };

  const onClickSideBar = () => {
    if (window.innerWidth > 850) {
      hideSubNav.set(false);
      sideDrawerState.set(!sideDrawerState.get());
    } else {
      hideSubNav.set(true);
      sideDrawerState.set(!sideDrawerState.get());
    }
  };

  const logoutUser = (data) => {
    if (data === "logout") {
      localStorage.removeItem("vkey");
      localStorage.removeItem("mapSideNavTabState");
      localStorage.removeItem("subNavDataState");
      localStorage.removeItem("subNavState");
      localStorage.removeItem("sideDrawerActiveTabState");
      dispatch(COMMON_SERVICES.resetStateChangePasswordService());
      handleLogout();
      hideSubNav.set(false);
      navigate("/");
    }
  };

  const menuId = "primary-search-account-menu";

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
      className="hello"
    >
      <TopMenuDropdown>
        <EmailIdMenu>
          <p>{getUserRole && getUserRole?.Name}</p>

          <span>
            {t("VCC_Version_Number") +
              " " +
              process.env.REACT_APP_PIPELINE_BUILD_NUMBER}
          </span>
        </EmailIdMenu>

        <MenuItem onClick={handleLanguage}>
          <MenuItemLi>
            <span>
              <LanguageMenuIcon />
            </span>
            {t("Language")}
          </MenuItemLi>
        </MenuItem>
        <MenuItem
          onClick={OpenUrl}
          sx={{
            display: { sm: "block", md: "none" },
          }}
        >
          <MenuItemLi>
            <span>
              <HelpOutlineIcon />
            </span>
            {t("Help")}
          </MenuItemLi>
        </MenuItem>
        <MenuItem onClick={() => setShowChangePasswordModal(true)}>
          <MenuItemLi>
            <span>
              <UnLockIcon />
            </span>
            {t("Change_Password")}
          </MenuItemLi>
        </MenuItem>
        <MenuItem onClick={() => logoutUser("logout")}>
          <MenuItemLi>
            <span>
              <LogoutIcon />
            </span>
            {t("Logout")}
          </MenuItemLi>
        </MenuItem>
      </TopMenuDropdown>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleLanguage}>{t("Language")}</MenuItem>
      <MenuItem onClick={() => logoutUser("logout")}>{t("Logout")}</MenuItem>
    </Menu>
  );

  const allSiteFunction = () => {
    selectSite.set(true);
    recentSiteState.set(true);
    callAllSiteFunction.set(false);
    let pathName = window.location.pathname;
    if (pathName !== "/map") {
      navigate("/map");
      sideDrawerActiveTabState.set(1);
      subNavDataState.set("MAP");
    }
    setTimeout(() => {
      siteLocationGlobalData.set(true);
      closeSnackbar();
      localStorage.setItem("allSite", true);
      subNavDataState.set("");
      siteListPopupOpen.set(false);
    }, 500);
  };

  useEffect(() => {
    let allSite = localStorage.getItem("allSite");
    if (allSite === "true") {
      allSiteFunction();
    }
  }, []);

  useEffect(() => {
    if (callAllSiteFunction.get()) allSiteFunction();
  }, [callAllSiteFunction.get()]);

  const [language, setLanguage] = React.useState("English");

  const handleCourseName = (e) => {
    setLanguage(e.target.value);
  };

  function handleAlertClick(identification, alertDetector) {
    if (alertDetector) {
      weatherAlertGlobalState.set(alertDetector);
      LoadingState.set(true);
      dispatch(
        COMMON_SERVICES.putFleetSettingsServices(
          {
            code: identification,
            Value: alertDetector,
          },
          siteId.get()
        )
      );
      setTimeout(() => {
        LoadingState.set(false);
      }, 2000);
      weatherAlertPopUpDisplayer.set(false);
    } else {
      weatherAlertGlobalState.set(alertDetector);
      LoadingState.set(true);
      dispatch(
        COMMON_SERVICES.putFleetSettingsServices(
          {
            code: identification,
            Value: false,
          },
          siteId.get()
        )
      );
      setTimeout(() => {
        LoadingState.set(false);
      }, 2000);
      weatherAlertPopUpDisplayer.set(false);
    }
  }

  const showPopupBox = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "400px",
      width: "100%",
      bgcolor: "#fff",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={weatherAlertPopUpDisplayer.get()}
        onClose={() => weatherAlertPopUpDisplayer.set(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Engage weather alert
            </Typography>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button
                onClick={() => handleAlertClick("WA", true)}
                className="primary"
              >
                {t("Yes")}
              </button>
              <button onClick={() => handleAlertClick("WA", false)}>
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    let changePasswordFormData = {
      OldPassword: oldPassword,
      NewPassword: newPassword,
      ConfirmPassword: confirmPassword,
    };

    dispatch(COMMON_SERVICES.postChangePasswordService(changePasswordFormData));
  }

  const showChangePasswordPopupBox = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "400px",
      width: "100%",
      bgcolor: "#fff",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={showChangePasswordModal}
        onClose={() => setShowChangePasswordModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <ChangePasswordPopup>
            <div className="header">{t("Change_Password")}</div>

            <form
              type="submit"
              onSubmit={(e) => handleChangePassword(e)}
              className="form-style"
            >
              <p id="modal-modal-description">{t("Current_password")}</p>
              <input
                type="password"
                name="OldPassword"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />

              <p id="modal-modal-description">{t("New_password")}</p>
              <input
                type="password"
                name="NewPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />

              <p id="modal-modal-description">{t("Confirm_new_password")}</p>
              <input
                type="password"
                name="ConfirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <ul className="password-text">
                {getChangePasswordState &&
                  Object.keys(getChangePasswordState).length !== 0 &&
                  getChangePasswordState?.errors.length !== 0 ? (
                  <>
                    {getChangePasswordState?.errors?.map((item) => {
                      return <li>{item}</li>;
                    })}
                  </>
                ) : (
                  <></>
                )}
              </ul>
              <div className="action-wrapper">
                <button
                  onClick={() => {
                    setShowChangePasswordModal(false);
                    dispatch(COMMON_SERVICES.resetStateChangePasswordService());
                    setOldPassword("");
                    setNewPassword("");
                    setConfirmPassword("");
                  }}
                >
                  {t("Cancel")}
                </button>
                <input type="submit" value={t("Save")} />
              </div>
            </form>
          </ChangePasswordPopup>
        </Box>
      </Modal>
    );
  }

  const showChangePasswordConfirmationPopupBox = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "400px",
      width: "100%",
      bgcolor: "#fff",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={showConfirmChangePasswordModal}
        onClose={() => setshowConfirmChangePasswordModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h4>Password Changed</h4>

            <div className="action-btn">
              <button onClick={() => {
                setshowConfirmChangePasswordModal(false);
              }}>
                {t("Ok")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  }

  let languagesList = {
    NameEn: "English",
    Namebg: "Български",
    Namezh: "中文(简体)",
    Namezk: "中文(繁體)",
    Namede: "Deutsch",
    Namees: "Español",
    Namefr: "Français",
    Nameja: "日本語",
    Nameko: "한국어",
    Nameru: "русский",
    Namecs: "čeština",
  };

  let languageListValue = {
    Langen: "enUS",
    Langbg: "bgBG",
    Langzh: "zhCN",
    Langzk: "zhHK",
    Langde: "deDE",
    Langes: "esES",
    Langfr: "frFR",
    Langja: "jaJP",
    Langko: "koKR",
    Langru: "ruRU",
    Langcs: "csCZ",
  };

  return (
    <>
      {subNavDataState.get().toUpperCase() !== "MAP" ||
        window.innerWidth < 850 ? (
        <Container className="for-other-section-header">
          <Box sx={{ flexGrow: 1 }}>
            <AppBar
              position="static"
              sx={{ height: "56px", bgcolor: "#fff", color: "#000" }}
              elevation={2}
              className="header-app"
            >
              <Toolbar
                sx={{
                  paddingLeft: { xs: "15px", sm: "0" },
                  paddingRight: { xs: "0", sm: "0" },
                  minHeight: "56px",
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    background: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: { xs: "0", sm: "0 15px" },
                  }}
                >
                  <Tooltip
                    className="tooltip"
                    title={`${t("VCC_Version_Number")} ${process.env.REACT_APP_PIPELINE_BUILD_NUMBER}`}
                  >
                    <img className="logo" src={Logo} alt="logo" />
                  </Tooltip>
                </Box>
                <Box
                  sx={{
                    borderRight: "1px solid #E5E5E5",
                    height: "100%",
                  }}
                ></Box>
                <Box
                  sx={{
                    height: "100%",
                    paddingLeft: "10px",
                    display: "flex",
                    alignItems: "center",
                    background: "#fff",
                  }}
                >
                  {sideDrawerState.get() ? (
                    <IconButton
                      size="large"
                      edge="start"
                      color="inherit"
                      aria-label="open drawer"
                      onClick={onClickSideBar}
                    >
                      <CloseIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      size="large"
                      edge="start"
                      color="inherit"
                      aria-label="open drawer"
                      onClick={onClickSideBar}
                    >
                      <MenuIcon color="#636F7C" />
                    </IconButton>
                  )}
                </Box>

                <Box
                  sx={{
                    borderRight: "1px solid #E5E5E5",
                    height: "100%",
                  }}
                ></Box>
                <Box
                  sx={{
                    display: { xs: "none", md: "flex" },
                    padding: "0 12px",
                    height: "100%",
                    background: "#fff",
                  }}
                >
                  <Tooltip title={t("Get_help")} placement="right" arrow>
                    <HelpContainer>
                      <IconButton onClick={OpenUrl}>
                        <HelpIcon style={{ cursor: "pointer" }} />

                        <Typography
                          variant="body2"
                          sx={{
                            display: { xs: "none", md: "flex" },
                            marginLeft: "5px",
                          }}
                        >
                          {t("Help")}
                        </Typography>
                      </IconButton>
                    </HelpContainer>
                  </Tooltip>
                </Box>
                {weatherAlertGlobalState.get() ? (
                  <Box
                    sx={{
                      border: "4px solid #E5E5E5",
                      borderColor: "red",
                      fontSize: "13px",
                    }}
                  >
                    <p>{t("Weather_Alert_Engaged")}</p>
                  </Box>
                ) : (
                  <></>
                )}
                <Box sx={{ flexGrow: 1 }} />
                <Modal
                  open={open}
                  onClose={handleClose2}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <PopUpContainer>
                      <h2>{t("Language")}:</h2>
                      <LanguageWrapper>
                        <Select
                          native
                          labelId="demo-controlled-open-select-label"
                          id="demo-controlled-open-select"
                          variant="outlined"
                          value={language}
                          onChange={handleCourseName}
                        >
                          <option value={languageListValue.Langen}>
                            {languagesList.NameEn}
                          </option>
                          <option value={languageListValue.Langbg}>
                            {languagesList.Namebg}
                          </option>
                          <option value={languageListValue.Langzh}>
                            {languagesList.Namezh}
                          </option>
                          <option value={languageListValue.Langzk}>
                            {languagesList.Namezk}
                          </option>
                          <option value={languageListValue.Langde}>
                            {languagesList.Namede}
                          </option>
                          <option value={languageListValue.Langes}>
                            {languagesList.Namees}
                          </option>
                          <option value={languageListValue.Langfr}>
                            {languagesList.Namefr}
                          </option>
                          <option value={languageListValue.Langja}>
                            {languagesList.Nameja}
                          </option>
                          <option value={languageListValue.Langko}>
                            {languagesList.Nameko}
                          </option>
                          <option value={languageListValue.Langru}>
                            {languagesList.Nameru}
                          </option>
                          <option value={languageListValue.Langcs}>
                            {languagesList.Namecs}
                          </option>
                        </Select>
                      </LanguageWrapper>
                      <div className="action-btn">
                        <button
                          onClick={() => {
                            i18next.changeLanguage(language);
                            setOpen(false);
                          }}
                          className="primary"
                        >
                          {t("Ok")}
                        </button>
                        <button onClick={() => setOpen(false)}>
                          {t("Cancel")}
                        </button>
                      </div>
                    </PopUpContainer>
                  </Box>
                </Modal>
                {siteLocationsData?.length == 1 ? (
                  <></>
                ) : (
                  <>
                    {!selectSite.get() && siteId.get() !== null ? (
                      <Tooltip
                        title={t("Show_all_sites")}
                        placement="left"
                        arrow
                      >
                        <Box
                          sx={{
                            display: { xs: "none", md: "flex" },
                            padding: "0 15px 0 0",
                            borderRight: "1px solid #E5E5E5;",
                            height: "100%",
                            alignItems: "center",
                            cursor: siteLocationGlobalData.get()
                              ? "not-allowed"
                              : "pointer",
                            background: "#fff",
                          }}
                        >
                          <IconButton onClick={allSiteFunction}>
                            <GlobeIcon />
                          </IconButton>
                        </Box>
                      </Tooltip>
                    ) : (
                      <></>
                    )}
                    <Box
                      sx={{
                        display: { xs: "flex", md: "flex" },
                        padding: "0 15px",
                        borderRight: "1px solid #E5E5E5;",
                        height: "100%",
                        alignItems: "center",
                        position: "relative",
                        cursor: "pointer",
                        background: "#fff",
                        flexDirection: "column",
                        gap: "1px",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          border: "1px solid #666666",
                          borderRadius: "6px",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                        onClick={handleClick}
                      >
                        <NavbarSelectValue>
                          {selectedSite}
                        </NavbarSelectValue>
                        <SelectDownArrowWrapper>
                          <SelectArrow />
                        </SelectDownArrowWrapper>
                      </Box>
                      {siteId.get() !== null &&
                        !selectSite.get() &&
                        time != null ? (
                        <CurrentTime>
                          {t("Time_on_site") + ": " + time}
                        </CurrentTime>
                      ) : (
                        <Loader width={40} height={40} />
                      )}
                    </Box>
                  </>
                )}
                <Modal
                  open={siteListPopupOpen.get()}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <SiteBoxContainer>
                    <SearchSection>
                      <SearchWrapper>
                        <SiteBoxInput
                          setSearchText={setSearchText}
                          isShown={siteListPopupOpen.get()}
                        />
                      </SearchWrapper>
                    </SearchSection>
                    <Container>
                      <>
                        {siteId.get() !== null && siteSelectionHistory ? (
                          <ResentSite>
                            {recentThreeSiteState
                              ?.slice(0, 3)
                              .map((item, index) => (
                                <li
                                  id={item?.Id}
                                  key={index}
                                  className="sitelink"
                                  onClick={(e) => {
                                    siteLocation(e);
                                    toast.dismiss();
                                  }}
                                >
                                  {sortConfig.field === "Id"
                                    ? `[${item?.Id}] - ${item?.Name}`
                                    : `${item?.Name} - ${item?.Id}`}
                                </li>
                              ))}
                          </ResentSite>
                        ) : null}

                        <AllSite id="myUL">
                          {sortedSites?.map(
                            (item, index) =>
                              ((!showInternal && !item.IsInternal) ||
                                showInternal) && (
                                <li
                                  key={index}
                                  className="sitelink"
                                  onClick={(e) => {
                                    siteLocation(e);
                                    toast.dismiss();
                                  }}
                                >
                                  <span id={item.Id}>
                                    {sortConfig.field === "Id"
                                      ? `[${item?.Id}] - ${item?.Name}`
                                      : `${item?.Name} - ${item?.Id}`}
                                  </span>
                                  {item.IsInternal && showInternal ? (
                                    <LockIcon width={18}></LockIcon>
                                  ) : (
                                    <></>
                                  )}
                                </li>
                              )
                          )}
                        </AllSite>
                      </>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          margin: "5px 20px",
                          justifyContent: "space-around",
                        }}
                      >
                        <Tooltip title={t("Sort_alphabetically")}>
                          <AllSiteBtn
                            className={nameSortActive ? "active" : "disabled"}
                            onClick={() => {
                              setIdSortActive(false);
                              setNameSortActive(true);
                              setSortConfig({
                                field: "Name",
                                isAscending: !sortConfig.isAscending,
                              });
                            }}
                          >
                            {sortConfig.field === "Name" &&
                              sortConfig.isAscending ? (
                              <FaSortAlphaDown
                                color={nameSortActive ? "white" : "black"}
                              />
                            ) : (
                              <FaSortAlphaDownAlt
                                color={nameSortActive ? "white" : "black"}
                              />
                            )}
                          </AllSiteBtn>
                        </Tooltip>
                        <Tooltip title={t("Sort_numerically")}>
                          <AllSiteBtn
                            className={idSortActive ? "active" : "disabled"}
                            onClick={() => {
                              setNameSortActive(false);
                              setIdSortActive(true);
                              setSortConfig({
                                field: "Id",
                                isAscending: !sortConfig.isAscending,
                              });
                            }}
                          >
                            {sortConfig.field === "Id" &&
                              sortConfig.isAscending ? (
                              <FaSortNumericUp
                                color={idSortActive ? "white" : "black"}
                              />
                            ) : (
                              <FaSortNumericDownAlt
                                color={idSortActive ? "white" : "black"}
                              />
                            )}
                          </AllSiteBtn>
                        </Tooltip>
                        <Tooltip
                          title={t("Show_internal_sites")}
                          placement="bottom"
                        >
                          <AllSiteBtn
                            className={showInternal ? "active" : "disabled"}
                            onClick={() => setShowInternal(!showInternal)}
                          >
                            <LockIcon
                              color={showInternal ? "white" : "black"}
                              width={18}
                            />
                          </AllSiteBtn>
                        </Tooltip>
                        <AllSiteBtn
                          className={
                            siteSelectionHistory ? "active" : "disabled"
                          }
                          onClick={() => {
                            setSiteSelectionHistory(!siteSelectionHistory);
                          }}
                        >
                          <FaClockRotateLeft />
                        </AllSiteBtn>
                        <Tooltip title={t("Show_all_sites")} placement="bottom">
                          <AllSiteBtn onClick={allSiteFunction}>
                            <GlobeIcon width={14} height={14} />
                          </AllSiteBtn>
                        </Tooltip>
                        <Tooltip title={t("Cancel")} placement="bottom">
                          <AllSiteBtn
                            onClick={() => {
                              siteListPopupOpen.set(false);
                            }}
                          >
                            {t("Cancel")}
                          </AllSiteBtn>
                        </Tooltip>
                      </div>
                    </Container>
                  </SiteBoxContainer>
                </Modal>
                <Box
                  sx={{
                    display: {
                      xs: "flex",
                      md: "flex",
                    },
                    background: "#fff",
                    height: "100%",
                    paddingRight: "15px",
                  }}
                >
                  <IconButton
                    size="large"
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={menuId}
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                  >
                    <AccountCircle />
                  </IconButton>
                </Box>
                <Box sx={{ display: { xs: "none", md: "none" } }}>
                  <IconButton
                    size="large"
                    aria-label="show more"
                    aria-controls={mobileMenuId}
                    aria-haspopup="true"
                    onClick={handleMobileMenuOpen}
                    color="inherit"
                  >
                    <MoreIcon />
                  </IconButton>
                </Box>
              </Toolbar>
            </AppBar>
            {renderMobileMenu}
            {renderMenu}
          </Box>
          {showPopupBox()}
          {showChangePasswordPopupBox()}
          {showChangePasswordConfirmationPopupBox()}
        </Container>
      ) : (
        <>
          <div className="for-map-header-left-section">
            <Box
              sx={{
                height: "100%",
                background: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: { xs: "0", sm: "0 15px" },
              }}
            >
              <Tooltip
                className="tooltip"
                title={
                  t("VCC_Version_Number") +
                  " " +
                  process.env.REACT_APP_PIPELINE_BUILD_NUMBER
                }
              >
                <img className="logo" src={Logo} alt="logo" />
              </Tooltip>
            </Box>
            <Box
              sx={{
                borderRight: "1px solid #E5E5E5",
                height: "100%",
              }}
            ></Box>
            <Box
              sx={{
                height: "100%",
                paddingLeft: "10px",
                display: "flex",
                alignItems: "center",
                background: "#fff",
              }}
            >
              {sideDrawerState.get() ? (
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={onClickSideBar}
                >
                  <CloseIcon />
                </IconButton>
              ) : (
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={onClickSideBar}
                >
                  <MenuIcon color="#636F7C" />
                </IconButton>
              )}
            </Box>

            <Box
              sx={{
                borderRight: "1px solid #E5E5E5",
                height: "100%",
              }}
            ></Box>
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                padding: "0 12px",
                height: "100%",
                background: "#fff",
              }}
            >
              <Tooltip title={t("Get_help")} placement="right" arrow>
                <HelpContainer>
                  <HelpIcon style={{ cursor: "pointer" }} onClick={OpenUrl} />

                  <Typography
                    variant="body2"
                    sx={{
                      display: { xs: "none", md: "flex" },
                    }}
                  >
                    {t("Help")}
                  </Typography>
                </HelpContainer>
              </Tooltip>
            </Box>
            {weatherAlertGlobalState.get() ? (
              <Box
                sx={{
                  border: "4px solid #E5E5E5",
                  borderColor: "red",
                  width: "173px",
                  fontSize: "13px",
                }}
              >
                <p>{t("Weather_Alert_Engaged")}</p>
              </Box>
            ) : (
              <></>
            )}
            <Modal
              open={open}
              onClose={handleClose2}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <PopUpContainer>
                  <h2>{t("Language")}:</h2>
                  <LanguageWrapper>
                    <Select
                      native
                      labelId="demo-controlled-open-select-label"
                      id="demo-controlled-open-select"
                      variant="outlined"
                      value={language}
                      onChange={handleCourseName}
                    >
                      <option value={languageListValue.Langen}>
                        {languagesList.NameEn}
                      </option>
                      <option value={languageListValue.Langbg}>
                        {languagesList.Namebg}
                      </option>
                      <option value={languageListValue.Langzh}>
                        {languagesList.Namezh}
                      </option>
                      <option value={languageListValue.Langzk}>
                        {languagesList.Namezk}
                      </option>
                      <option value={languageListValue.Langde}>
                        {languagesList.Namede}
                      </option>
                      <option value={languageListValue.Langes}>
                        {languagesList.Namees}
                      </option>
                      <option value={languageListValue.Langfr}>
                        {languagesList.Namefr}
                      </option>
                      <option value={languageListValue.Langja}>
                        {languagesList.Nameja}
                      </option>
                      <option value={languageListValue.Langko}>
                        {languagesList.Nameko}
                      </option>
                      <option value={languageListValue.Langru}>
                        {languagesList.Nameru}
                      </option>
                      <option value={languageListValue.Langcs}>
                        {languagesList.Namecs}
                      </option>
                    </Select>
                  </LanguageWrapper>
                  <div className="action-btn">
                    <button
                      onClick={() => {
                        i18next.changeLanguage(language);
                        setOpen(false);
                      }}
                      className="primary"
                    >
                      {t("Ok")}
                    </button>
                    <button onClick={() => setOpen(false)}>
                      {t("Cancel")}
                    </button>
                  </div>
                </PopUpContainer>
              </Box>
            </Modal>
          </div>
          <div className="for-map-header-right-section">
            {siteLocationsData?.length == 1 ? (
              <></>
            ) : (
              <>
                <Tooltip title={t("Show_all_sites")} placement="left">
                  <Box
                    sx={{
                      display: { xs: "none", md: "flex" },
                      padding: "0 15px ",
                      borderRight: "1px solid #E5E5E5;",
                      height: "100%",
                      alignItems: "center",
                      cursor: "pointer",
                      background: "#fff",
                    }}
                    onClick={() => {
                      if (addActionZonePolygon.get()) {
                        openAZdiscardPopup.set(true);
                        redirectState.set(false);
                      } else {
                        allSiteFunction();
                      }
                    }}
                  >
                    <GlobeIcon />
                  </Box>
                </Tooltip>
                <Box
                  sx={{
                    display: { xs: "flex", md: "flex" },
                    padding: "0 15px",
                    borderRight: "1px solid #E5E5E5;",
                    height: "100%",
                    alignItems: "center",
                    position: "relative",
                    cursor: "pointer",
                    background: "#fff",
                    flexDirection: "column",
                    gap: "1px",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      border: "1px solid #666666",
                      borderRadius: "6px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                    onClick={handleClick}
                  >
                    <NavbarSelectValue>
                      {selectedSite}
                    </NavbarSelectValue>
                    <SelectDownArrowWrapper>
                      <SelectArrow />
                    </SelectDownArrowWrapper>
                  </Box>
                  {siteId.get() !== null &&
                    !selectSite.get() &&
                    time != null ? (
                    <CurrentTime>{t("Time_on_site") + ": " + time}</CurrentTime>
                  ) : (
                    <Loader width={40} height={40} />
                  )}
                </Box>
              </>
            )}
            <Modal
              open={siteListPopupOpen.get()}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <SiteBoxContainer>
                <SearchSection>
                  <SearchWrapper>
                    <SiteBoxInput
                      setSearchText={setSearchText}
                      isShown={siteListPopupOpen.get()}
                    />
                  </SearchWrapper>
                  <button
                    style={{
                      background: "transparent",
                      border: "none",
                      float: "right",
                    }}
                    onClick={() => {
                      setSiteSelectionHistory(!siteSelectionHistory);
                    }}
                  >
                    <FaClockRotateLeft
                      btncolorprops={
                        siteSelectionHistory
                          ? "var(--theme-background)"
                          : "transparent"
                      }
                    />
                  </button>
                </SearchSection>
                <Container>
                  <>
                    {siteId.get() !== null && siteSelectionHistory ? (
                      <ResentSite>
                        {recentThreeSiteState
                          ?.slice(0, 3)
                          .map((item, index) => (
                            <li
                              id={item?.Id}
                              key={index}
                              className="sitelink"
                              onClick={(e) => {
                                siteLocation(e);
                                toast.dismiss();
                              }}
                            >
                              {sortConfig.field === "Id"
                                ? `[${item?.Id}] - ${item?.Name}`
                                : `${item?.Name} - ${item?.Id}`}
                            </li>
                          ))}
                      </ResentSite>
                    ) : null}

                    <AllSite id="myUL">
                      {sortedSites?.map(
                        (item, index) =>
                          ((!showInternal && !item.IsInternal) ||
                            showInternal) && (
                            <li
                              key={index}
                              className="sitelink"
                              onClick={(e) => {
                                siteLocation(e);
                                toast.dismiss();
                              }}
                            >
                              <span id={item.Id}>
                                {sortConfig.field === "Id"
                                  ? `[${item?.Id}] - ${item?.Name}`
                                  : `${item?.Name} - ${item?.Id}`}
                              </span>
                              {item.IsInternal && showInternal ? (
                                <LockIcon width={18}></LockIcon>
                              ) : (
                                <></>
                              )}
                            </li>
                          )
                      )}
                    </AllSite>
                  </>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "5px 20px",
                      justifyContent: "space-around",
                    }}
                  >
                    <Tooltip title={t("Sort_alphabetically")}>
                      <AllSiteBtn
                        className={nameSortActive ? "active" : "disabled"}
                        onClick={() => {
                          setIdSortActive(false);
                          setNameSortActive(true);
                          setSortConfig({
                            field: "Name",
                            isAscending: !sortConfig.isAscending,
                          });
                        }}
                      >
                        {sortConfig.field === "Name" &&
                          sortConfig.isAscending ? (
                          <FaSortAlphaDown
                            color={nameSortActive ? "white" : "black"}
                          />
                        ) : (
                          <FaSortAlphaDownAlt
                            color={nameSortActive ? "white" : "black"}
                          />
                        )}
                      </AllSiteBtn>
                    </Tooltip>
                    <Tooltip title={t("Sort_numerically")}>
                      <AllSiteBtn
                        className={idSortActive ? "active" : "disabled"}
                        onClick={() => {
                          setNameSortActive(false);
                          setIdSortActive(true);
                          setSortConfig({
                            field: "Id",
                            isAscending: !sortConfig.isAscending,
                          });
                        }}
                      >
                        {sortConfig.field === "Id" && sortConfig.isAscending ? (
                          <FaSortNumericUp
                            color={idSortActive ? "white" : "black"}
                          />
                        ) : (
                          <FaSortNumericDownAlt
                            color={idSortActive ? "white" : "black"}
                          />
                        )}
                      </AllSiteBtn>
                    </Tooltip>
                    <Tooltip
                      title={t("Show_internal_sites")}
                      placement="bottom"
                    >
                      <AllSiteBtn
                        className={showInternal ? "active" : "disabled"}
                        onClick={() => setShowInternal(!showInternal)}
                      >
                        <LockIcon
                          color={showInternal ? "white" : "black"}
                          width={18}
                        />
                      </AllSiteBtn>
                    </Tooltip>
                    <AllSiteBtn
                      className={siteSelectionHistory ? "active" : "disabled"}
                      onClick={() => {
                        setSiteSelectionHistory(!siteSelectionHistory);
                      }}
                    >
                      <FaClockRotateLeft />
                    </AllSiteBtn>
                    <Tooltip title={t("Show_all_sites")} placement="bottom">
                      <AllSiteBtn onClick={allSiteFunction}>
                        <GlobeIcon width={14} height={14} />
                      </AllSiteBtn>
                    </Tooltip>
                    <Tooltip title={t("Cancel")} placement="bottom">
                      <AllSiteBtn
                        onClick={() => {
                          siteListPopupOpen.set(false);
                        }}
                      >
                        {t("Cancel")}
                      </AllSiteBtn>
                    </Tooltip>
                  </div>
                </Container>
              </SiteBoxContainer>
            </Modal>
            <Box
              sx={{
                display: {
                  xs: "flex",
                  md: "flex",
                },
                background: "#fff",
                height: "100%",
                paddingRight: "15px",
              }}
            >
              <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
            </Box>
            <Box sx={{ display: { xs: "none", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            </Box>
          </div>
          {renderMobileMenu}
          {renderMenu}
          {showPopupBox()}
          {showChangePasswordPopupBox()}
          {showChangePasswordConfirmationPopupBox()}
        </>
      )}
    </>
  );
};

const NavbarSelectValue = styled.p`
  padding: 8px 12px 8px 8px;
  font-size: 14px;

  @media (max-width: 850px) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90px;
    padding: 2px 6px 2px 8px;
    font-size: 13px;
  }
`;

const SelectDownArrowWrapper = styled.span`
  padding-right: 10px;
  @media (max-width: 850px) {
    padding-right: 6px;
  }
`;

const MenuItemLi = styled.div`
  display: grid;
  grid-template-columns: 32px auto;
  align-items: center;
  min-width: 150px;
  gap: 10px;
  font-size: 16px;
  width: 100%;
  min-height: 49px;
  &.bdr-tp {
    border-top: 1px dashed #00000080;
    padding-top: 10px;
  }
  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const LanguageWrapper = styled.div`
  padding: 0 20px 30px;
  .MuiInputBase-root {
    width: 100%;
  }
  .MuiNativeSelect-select {
    font-size: 14px;
    padding: 7.5px 14px;
  }
`;

const EmailIdMenu = styled.div`
  p {
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    padding: 0 15px;
    white-space: nowrap;
    width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  span {
    font-weight: 200;
    font-size: 16px;
    line-height: 40px;
    padding: 0 30px;
    width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  display: inline-block;
  align-items: center;
  min-height: 58px;
  border-bottom: 1px solid #eeeeee;
  margin: 0 10px 8px;
`;

const TopMenuDropdown = styled.ul`
  padding: 0 10px;
  > li:hover {
    background: #f2f6ff;
    border-radius: 15px;
    color: #0093dd;
  }
`;

const CurrentTime = styled.p`
  color: #fff;
  font-size: 12px;
  background: #6b5c4b;
  padding: 0 15px;
  border-radius: 7px;
  border: 1px solid #fff;
  font-weight: bolder;
  letter-spacing: 0.9px;
  @media (max-width: 850px) {
    padding: 1px 10px;
    width: 117px;
    text-align: center;
    font-size: 10px;
  }
`;
